import { useMemo } from "react";

export interface GmailSourceSettingsText {
  labelText: string;
  hintText: string;
  allLabelsText: string;
  loadingText: string;
  loadErrorText: string;
  starredText: string;
  starredHintText: string;
}

export const useGmailSourceSettingsText = (
  t: (key: string) => string,
): GmailSourceSettingsText => {
  return useMemo(() => {
    const tKey = (key: string): string =>
      t(`board.connections.dialog.sourceSettings.gmail.${key}`);

    return {
      labelText: tKey("label"),
      hintText: tKey("hint"),
      allLabelsText: tKey("allLabels"),
      loadingText: tKey("loading"),
      loadErrorText: tKey("loadError"),
      starredText: tKey("starred"),
      starredHintText: tKey("starredHint"),
    };
  }, [t]);
};
